/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useState } from 'react';
import { useMount, useUnmount } from 'ahooks';
import { Toast } from 'antd-mobile-v5';
import { registerWindowFn, jsTakePhoto } from '@/utils/bridge';
import { MAX_ATTACHMENT_SIZE, ID_CARD_SIDE } from '../../config.js';
import styles from './index.less';

const ImageUpload = ({
  isUploaded,
  uploadItem,
  value = [],
  onPhotoChange,
  maxImageSize = MAX_ATTACHMENT_SIZE,
}) => {
  const [fileList, setFileList] = useState([]);

  const getImageSize = base64 => {
    const strLength = base64.length;
    const fileLength = strLength - (strLength / 8) * 2;
    return Math.floor(fileLength);
  };

  const jsTakePhotoCallback = useCallback(
    res => {
      if (res?.code === 0 && res.data.image) {
        // Toast.clear();
        const imageSize = getImageSize(res.data.image);
        if (imageSize <= maxImageSize * 1024) {
          // const imageWithPrefix = `data:image/png;base64,${res.data.image}`;
          const imageWithPrefix = `${res.data.image}`;
          onPhotoChange(imageWithPrefix, uploadItem.side);
        } else {
          Toast.show(`图片不能超过${maxImageSize}K`);
        }
      } else {
        Toast.show(res.msg || '选择图片失败');
      }
    },
    [fileList, maxImageSize]
  );

  const hanldeInputFileClick = e => {
    e.stopPropagation();
  };

  const imagePicked = base64 => {
    // console.log('base64 ', base64);
  };

  const handleUploadClick = e => {
    e.preventDefault();
    // 调用原生方法选择图片
    // Toast.show({
    //   icon: 'loading',
    //   content: '加载中…',
    // });
    jsTakePhoto(jsTakePhotoCallback);
  };

  useMount(() => {
    registerWindowFn('imagePicked', imagePicked);
    setFileList(value || []);
  });

  useUnmount(() => {
    setFileList([]);
  });

  return (
    <>
      <label
        className={`${styles.uploaderPicker} ${styles[uploadItem.id]}`}
        htmlFor={uploadItem.id}
        onClick={handleUploadClick}
      >
        <img
          ref={uploadItem.imgRef}
          alt={uploadItem.id}
          className={isUploaded ? styles.uploaded : ''}
        />
        <input
          ref={uploadItem.inputRef}
          type="file"
          id={uploadItem.id}
          name={uploadItem.id}
          accept="image/*"
          placeholder=""
          onClick={hanldeInputFileClick}
        />
        <p className={styles.uploaderName}>{uploadItem.label}</p>
        <i className={styles.cameraBtn} />
      </label>
    </>
  );
};
export default ImageUpload;
